module.exports = __webpack_public_path__ + "static/media/404.2f28b784.svg";